import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import {Material, OutwardMaterial} from '../../../shared/classes/Material'
import { Outward } from '../../../shared/classes/Outward'; 
import { Location } from '@angular/common';
import {Applicationuser} from '../../../shared/classes/users';
import { Practice,RequestType } from '../../../shared/classes/MasterOutwardData';
import { City, Office } from '../../../shared/classes/users';
import { OutwardService } from '../../../shared/services/outward.service';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataContextService } from '../../../shared/services/data-context.service';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from '../../../shared/services/Constants/constants.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UploadmaterialComponent } from '../../../shared/components/uploadmaterial/uploadmaterial.component';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { city } from '../../../shared/classes/city';
import { Role } from '../../../Enum/role';
//import { office } from '../../../shared/classes/office';
import { filterData, OfficeFilter } from '../../../shared/classes/filter';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '../../../shared/services/users.service';
import { NgForm } from '@angular/forms';
import { ThisReceiver } from '@angular/compiler';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';
import { AuditData, AuditMaterial, TransactionAuditTrail } from 'src/app/shared/classes/AuditTrail';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import { ModalSize } from 'src/app/Enums/usersFilterEnums';
import { UploadMaterialComponent } from '../../upload-material/upload-material.component';
import { FileService } from 'src/app/shared/services/file.service';

//import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-add-outward',
  templateUrl: './add-outward.component.html',
  styleUrls: ['./add-outward.component.less']
})
export class AddOutwardComponent implements OnInit {
  MasterList:any;
  public officeData: Office[];
  dateInputData: any = {};
  RequestName:string;
  Remarks:string="";
  Purpose:string;
  MaterialCarriedBy:string;
  LaApprov1:string;
  LaApprov2:string;
  AuthorizedBy:string;
  PracticeDetails:Practice;
  Appr1Details:Applicationuser;
  Appr2Details:Applicationuser;
  Roles:any;
  CityDetails:city;
  OfficeDetails:Office;
  RequestTypeDetails:RequestType;
  public PracticeData: any;
  public Appr1Data:Applicationuser[];
  public Appr2Data:Applicationuser[];

  public cityData:City[];
  //public OfficeData:Office[];
  public RequestTypeData:RequestType[];
  typeaheadRequestorLoading: boolean;
  modalRef: BsModalRef;
  OutwardDetails:Outward;
  EditOutwardDetails:any;
  EditDetails:Outward;
  public materialList:OutwardMaterial[] = [];
  data:any;
  materialSentToDataSource: Observable<any>;
  PracticeSelected:number;
  Appr1Selected:number;
  Appr2Selected:number;
  CitySelected:number;
  OfficeSelected:number;
  MaterialSentTo:string;
  RequestSelected:number;
  purpose: string;
  fromtimepickervalue: Date = new Date();
  duetimepickervalue:Date=new Date();
  revisedduetimepickervalue:Date=new Date();
  fTime: Date = new Date;
  dTime:Date=new Date;
  rTime:Date=new Date;
  fromtimevalue: any;
  duetimevalue:any;
  revisedduetimevalue:any;
  outwardData:any;
  isValidTime: boolean = true;
  private service_URL: any;
  RequestTypeName:any;
  RequestStatusName:any
  OfficeName:any;
  PracticeName:any;
  Appr1Name:any;
  Appr2Name:any;
  private unsubscribe$ =new Subject<void>();
  totalCount: any;
  flag: boolean;
  isSpinning: boolean;
  selectedCityId:Array<any>=[];
  exittime: any;
  exTime: Date;
  timevalue: any;
  id:number;
  @ViewChild('fromtime') fromtime: ElementRef;
  @ViewChild('outwardregform') outwardregfrom : NgForm;
  iseditTransaction: boolean;
  appr1: any;
  appr2: any;
  mstep: number = 1;
  OutwardStatus: OutwardStatus;
  previousValidDueDate: Date;
  private initialAttachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  private deletedFileIds: number[] = [];
  //Audit Variables
  oldValues: any = [];
  newValues: any = [];
  oldCopyMaterialList: any;
  oldMaterialList: any = [];
  newMaterialList: any = [];
  oldRequestData: any;
  newRequestData: any;
  auditResult: TransactionAuditTrail = new TransactionAuditTrail();
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  attachedFilesDetails: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  showUploadMaterial: boolean = false;
  showButtonFlag: boolean = false;
  constructor(private location: Location, private modalService: BsModalService,private userService: UsersService,private outwardService: OutwardService, private httpClient : HttpClient, 
    private _dataContextService: DataContextService,private route: ActivatedRoute,private http:HttpClient,
    private toast: ToastrService,private trackeromnitureservice:TrackerOmnitureService,private fileService: FileService) {this.service_URL = ConstantsService;
    this.PracticeDetails=new Practice(); 
    this.Appr1Details=new Applicationuser();
    this.Appr2Details=new Applicationuser();
    this.OfficeDetails=new Office();
    this.RequestTypeDetails=new RequestType();
    this.OutwardDetails=new Outward();
    this.EditDetails=new Outward();}

  ngOnInit() {
  
    this.fileService.files$.subscribe(files => {
      if (this.attachedFiles && this.attachedFiles.length > 0) {
        const newFiles = files.filter(file => file.requestType === 'Outward');
        newFiles.forEach(newFile => {
          const exists = this.attachedFiles.some(attachedFile => attachedFile.name === newFile.name);
          if (!exists) {
            this.attachedFiles.push(newFile);
            this.attachedFilesDetails.push(newFile);
          }
        });
      } else {
        this.attachedFiles = files.filter(file => file.requestType === 'Outward');
        this.attachedFilesDetails = [...this.attachedFiles];
      }
    });

    this.fileService.clearFiles();
   // this.initialAttachedFiles = JSON.parse(JSON.stringify(this.attachedFiles));
    this.id = this.route.snapshot.params['id'];
  
    this.fromtimevalue = this.GetTimeForDates(new Date);
    this.duetimevalue=this.GetTimeForDates(new Date);
    this.revisedduetimevalue=this.GetTimeForDates(new Date);
    
    // Set Request Date minimum to today (no past dates) and maximum to 5 working days from today
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.maxDate = this.addWorkingDays(new Date(), 5);
    this.dateInputData.RequestDate = new Date();
    
    // Set Due Date minimum to same day as request date and maximum to 168 days from request date
    this.dateInputData.FromMinToDate = new Date();
    this.dateInputData.maxToDate = new Date();
    this.dateInputData.maxToDate.setDate(this.dateInputData.maxToDate.getDate() + 168);
    
        this.getOutwardMasterData();
       
        if(this.id!=undefined)
        {
         this.iseditTransaction=true;
        }
        var username = localStorage.getItem('email');
        username = username.split('@')[0];
        this.trackeromnitureservice.trackPageloadData('add-ourtward',username);
        this.trackeromnitureservice.trackPage("pageView"); 

       
  }
 
  showButton(){
    if(this.RequestTypeName && this.PracticeSelected && this.OfficeName&& this.CitySelected 
      && this.Appr1Selected && this.Appr2Selected && this.Purpose && this.outwardregfrom.valid &&  this.materialList.length > 0){
      // Material List Validation
      if(this.materialList.length > 0){
        var flag = false;
        for(var i=0;i<this.materialList.length;i++){
          flag = false;
        var task = this.materialList[i];
          if(task.name == '' || task.quantity == null|| task.quantity==0){
            flag = true;
            break;
          }
        }
        if(flag){
          return true;
        }
      }
      return false;
    }
    return true;
  }
  
  //To load cities data in Grid
  getOutwardMasterData() {
    this._dataContextService.get<any>(this.service_URL.Master.OutwardMasterData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.MasterList = res;
      this.cityData = this.MasterList.cityList;
      // this.Appr1Data=this.MasterList.usersList.filter(x=>x.isL1==true);
      // this.Appr2Data=this.MasterList.usersList.filter(x=>x.isL2==true);
      this.Appr1Data = [];
      this.Appr2Data = [];
      this.PracticeData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      this.RequestTypeData=this.MasterList.requestType.filter(x=>x.category=='outwardrequesttype');
      this.officeData = this.MasterList.officeList;
      if(this.iseditTransaction) 
      {
       this.getDataById(this.id);
       //this.RequestName=this.OutwardDetails.requestName;
      }  
    })
  }

  
  isFromValid(event: any) {
    this.isValidTime = event;
  }
  selectCity(){
    
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
    }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);

    // let item=this.cityData.find(x=>x.cityId==this.CitySelected);
    // this.selectedCityId.push(item);
    // this.cityData=this.cityData.filter(x=>x.cityId!=item.cityId).sort((item1,item2)=>(item1.cityName < item2.cityName)?-1:1);
  }
  OnchangeCity(event) {
    
    if(this.CitySelected == null)
    {
      var tempo : Array<any>=[];
      var temp : Array<any>=[];
      let i=0;
      for(i=0;i<this.selectedCityId.length;i++){
        tempo= this.MasterList.office.filter((item) => {
          return item.cityId === this.selectedCityId[i].cityId
        });

        // temp.concat(tempo);
         temp = temp.concat(tempo);
  
      }
      this.officeData =   temp.sort((item1,item2)=>(item1.displayName < item2.displayName)?-1:1);

      this.filterApprovers();
    }
   
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
      }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    }
  fromTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.fTime).format('MM/DD/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.fTime = new Date(input);
    this.fromtimevalue = this.GetTimeForDates(this.fTime);
  }
  dueTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.dTime).format('MM/DD/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.dTime = new Date(input);
    this.duetimevalue = this.GetTimeForDates(this.dTime);
    if(this.RequestTypeName=='Returnable' && !this.iseditTransaction){
      this.revisedduetimevalue = this.GetTimeForDates(this.dTime);
    }
  }
  rdueTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.rTime).format('MM/DD/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.rTime = new Date(input);
    this.revisedduetimevalue = this.GetTimeForDates(this.rTime);
   
  }
  PrepareUsersObj() {
    //Converting Status Filter response to Boolean 
    var sArray: Array<boolean> = new Array();
    
    OfficeFilter.statusList.forEach(element => {
      element === 'Active' ? sArray.push(true) : sArray.push(false);
    });
  
    let params = {
        // Status: OfficeFilter.statusList,
        Status: sArray,       
        // Role: OfficeFilter.roleList,
        // Office: UsersFilterService.officesList,
        City: OfficeFilter.cityList
        //SearchByName: this.userName,
       // PageNo: this.filterData.page
    };
  
    return params;
  }
  OnCityChange(){}
  
  OnPracticeChange(val)
  {
    this.Appr1Data=this.MasterList.usersList.filter(x=>x.isL1==true);
    this.Appr2Data=this.MasterList.usersList.filter(x=>x.isL2==true);
    this.PracticeName=val;
    this.Appr1Data=this.Appr1Data.filter(x=>x.practiceID==this.PracticeName);
    this.Appr2Data=this.Appr2Data.filter(x=>x.practiceID==this.PracticeName);
    this.filterApprovers();
  }
  OnAppr1Change(val)
  {
this.Appr1Name=val;
  }
  OnAppr2Change(val)
  {
this.Appr2Name=val;
  }
  timePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.exTime).format('MM/DD/YYYY') + ', ' + this.exittime.nativeElement.value;
    }
    this.exTime = new Date(input);
    this.timevalue = this.GetTimeForDates(this.exTime);
  }
  GetTimeForDates(date: Date): string {
    let time = moment(date).format("hh:mm A");
    return time;
  }

  // Helper function to add working days (excluding weekends)
  addWorkingDays(date: Date, daysToAdd: number): Date {
    const result = new Date(date);
    let addedDays = 0;
    
    while (addedDays < daysToAdd) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }
    
    return result;
  }

  // Validate request date is within allowed range
  validateRequestDate(selectedDate: Date): void {
    if (!selectedDate) return;
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    const maxDate = this.addWorkingDays(new Date(), 5);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < today) {
      this.toast.error('Request date cannot be in the past');
      this.dateInputData.RequestDate = new Date();
    } else if (selected > maxDate) {
      this.toast.error('Request date cannot be more than 5 working days from today');
      this.dateInputData.RequestDate = new Date();
    }
    
    // Update due date constraints when request date changes
    this.updateDueDateConstraints(this.dateInputData.RequestDate);
  }

  // Update due date min/max based on request date
  updateDueDateConstraints(requestDate: Date): void {
    if (!requestDate) return;
    
    // Due date minimum is the same day as request date
    this.dateInputData.FromMinToDate = new Date(requestDate);
    
    // Due date maximum is 168 days from request date
    const maxDueDate = new Date(requestDate);
    maxDueDate.setDate(maxDueDate.getDate() + 168);
    this.dateInputData.maxToDate = maxDueDate;
    
    // If current due date is before new minimum, reset it
    if (this.dateInputData.DueDate && this.dateInputData.DueDate < requestDate) {
      this.dateInputData.DueDate = new Date(requestDate);
    }
  }

  OnRequestChange(val){
    
    this.RequestTypeName=val;
    // console.log(this.RequestSelected);
  }
  OnOfficeChange(val){
    this.OfficeName=val;
    this.filterApprovers();
  }

filterApprovers() {
  // Only populate if all three are selected
  if (!this.PracticeName || !this.CitySelected || !this.OfficeName) {
    this.Appr1Data = [];
    this.Appr2Data = [];
    return;
  }
 
  // Convert to string for easier comparison
  const selectedPractice = this.PracticeName.toString();
  const selectedCity = this.CitySelected.toString();
  const selectedOffice = this.OfficeName.toString();
 
  // Helper to check if a value is in a comma-separated string
  const containsId = (ids: string, id: string) =>
    ids && ids.split(',').map(x => x.trim()).includes(id);
 
  // Helper to check if user has L1 role for the selected office in userOffices
  const hasL1RoleForOffice = (user: any) => {
    if (!this.MasterList.userOffices || this.MasterList.userOffices.length === 0) {
      return user.isL1 === true;
    }
    // Find all userOffice entries for this user and selected office
    const userOfficesForSelectedOffice = this.MasterList.userOffices.filter(uo =>
      uo.appUserID === user.appUserID &&
      (uo.officeID == selectedOffice || containsId(uo.officeIDs, selectedOffice))
    );
   
    if (userOfficesForSelectedOffice.length > 0) {
      // Check if any of the matching userOffices has L1 role
      return userOfficesForSelectedOffice.some(uo => uo.isL1 === true);
    } else {
      // Fallback to user's general isL1 property
      return user.isL1 === true;
    }
  };
 
  // Helper to check if user has L2 role for the selected office in userOffices
  const hasL2RoleForOffice = (user: any) => {
    if (!this.MasterList.userOffices || this.MasterList.userOffices.length === 0) {
      return user.isL2 === true;
    }
    // Find all userOffice entries for this user and selected office
    const userOfficesForSelectedOffice = this.MasterList.userOffices.filter(uo =>
      uo.appUserID === user.appUserID &&
      (uo.officeID == selectedOffice || containsId(uo.officeIDs, selectedOffice))
    );
   
    if (userOfficesForSelectedOffice.length > 0) {
      // Check if any of the matching userOffices has L2 role
      return userOfficesForSelectedOffice.some(uo => uo.isL2 === true);
    } else {
      // Fallback to user's general isL2 property
      return user.isL2 === true;
    }
  };
 
  // Helper to check if user has L1 role for the selected practice in userPractices
  const hasL1RoleForPractice = (user: any) => {
    if (!this.MasterList.userPractices || this.MasterList.userPractices.length === 0) {
      return user.isL1 === true;
    }
    // Find all userPractice entries for this user and selected practice
    const userPracticesForSelectedPractice = this.MasterList.userPractices.filter(up =>
      up.appUserID === user.appUserID &&
      (up.practiceID == selectedPractice || containsId(up.practiceIDs, selectedPractice))
    );
 
    if (userPracticesForSelectedPractice.length > 0) {
      // Check if any of the matching userPractices has L1 role
      return userPracticesForSelectedPractice.some(up => up.isL1 === true);
    } else {
      // Fallback to user's general isL1 property
      return user.isL1 === true;
    }
  };
 
  // Helper to check if user has L2 role for the selected practice in userPractices
  const hasL2RoleForPractice = (user: any) => {
    if (!this.MasterList.userPractices || this.MasterList.userPractices.length === 0) {
      return user.isL2 === true;
    }
    // Find all userPractice entries for this user and selected practice
    const userPracticesForSelectedPractice = this.MasterList.userPractices.filter(up =>
      up.appUserID === user.appUserID &&
      (up.practiceID == selectedPractice || containsId(up.practiceIDs, selectedPractice))
    );
 
    if (userPracticesForSelectedPractice.length > 0) {
      // Check if any of the matching userPractices has L2 role
      return userPracticesForSelectedPractice.some(up => up.isL2 === true);
    } else {
      // Fallback to user's general isL2 property
      return user.isL2 === true;
    }
  };
 
  // Filter L1 Approvers
  this.Appr1Data = this.MasterList.usersList.filter(x =>
    hasL1RoleForOffice(x) &&
    hasL1RoleForPractice(x) &&
    (selectedPractice
      ? (containsId(x.practiceIDs, selectedPractice) || x.practiceID == selectedPractice)
      : true) &&
    (selectedCity
      ? (containsId(x.cityIDs, selectedCity) || x.cityID == selectedCity)
      : true) &&
    (selectedOffice
      ? (containsId(x.officeIDs, selectedOffice) || x.officeID == selectedOffice)
      : true)
  );
 
  // Filter L2 Approvers
  this.Appr2Data = this.MasterList.usersList.filter(x =>
    hasL2RoleForOffice(x) &&
    hasL2RoleForPractice(x) &&
    (selectedPractice
      ? (containsId(x.practiceIDs, selectedPractice) || x.practiceID == selectedPractice)
      : true) &&
    (selectedCity
      ? (containsId(x.cityIDs, selectedCity) || x.cityID == selectedCity)
      : true) &&
    (selectedOffice
      ? (containsId(x.officeIDs, selectedOffice) || x.officeID == selectedOffice)
      : true)
  );
}




  receivename($event) {  
    this.data = $event;  
  }
  sendData(val:object)
  {
    // console.log("send value");
  }
  onDueDateChanged(newDate: any): void {
    // Sync revised date with due date
    this.dateInputData.RevisedDate = newDate;
  }

  // Validate due date is within allowed range
  validateDueDate(selectedDate: Date): void {
    if (!selectedDate || !this.dateInputData.RequestDate) return;
    
    // Initialize previousValidDueDate if not set
    if (!this.previousValidDueDate) {
      this.previousValidDueDate = new Date(this.dateInputData.RequestDate);
    }
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    // Due date minimum should be the request date (not before it)
    const minDate = new Date(this.dateInputData.RequestDate);
    minDate.setHours(0, 0, 0, 0);
    
    const maxDate = new Date(this.dateInputData.maxToDate);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < minDate) {
      this.toast.error('Due date cannot be before the request date');
      // Reset to previous valid date (e.g., if was 20, reset back to 20)
      this.dateInputData.DueDate = new Date(this.previousValidDueDate);
      this.dateInputData.RevisedDate = new Date(this.previousValidDueDate);
    } else if (selected > maxDate) {
      this.toast.error('Due date cannot be more than 168 days from the request date');
      // Reset to previous valid date (e.g., if was 20, reset back to 20)
      this.dateInputData.DueDate = new Date(this.previousValidDueDate);
      this.dateInputData.RevisedDate = new Date(this.previousValidDueDate);
    } else {
      // Valid date - update stored valid date and sync revised due date with due date
      this.previousValidDueDate = new Date(selectedDate);
      this.dateInputData.RevisedDate = new Date(selectedDate);
    }
  }

  // Validate revised due date is within allowed range
  validateRevisedDueDate(selectedDate: Date): void {
    if (!selectedDate || !this.dateInputData.RequestDate) return;
    
    // Use due date as the previous valid date (revised date should match due date)
    const previousValidDate = this.dateInputData.DueDate ? new Date(this.dateInputData.DueDate) : new Date(this.dateInputData.RequestDate);
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    // Revised due date minimum should be the request date (not today)
    const minDate = new Date(this.dateInputData.RequestDate);
    minDate.setHours(0, 0, 0, 0);
    
    const maxDate = new Date(this.dateInputData.maxToDate);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < minDate) {
      this.toast.error('Revised due date cannot be before the request date');
      // Reset to due date (keep them in sync)
      this.dateInputData.RevisedDate = previousValidDate;
    } else if (selected > maxDate) {
      this.toast.error('Revised due date cannot be more than 168 days from the request date');
      // Reset to due date (keep them in sync)
      this.dateInputData.RevisedDate = previousValidDate;
    }
  }

  addMaterial(){
    this.materialList.push(new OutwardMaterial())
    
  }
  uploadMaterial()
  {
    this.modalRef = this.modalService.show(UploadmaterialComponent)
    // console.log(this.data);
    this.modalRef.content.event.subscribe(res => {
    //  console.log(res);
    });
   // this.modalRef.afterClosed().subscribe()
  }
  changeRequestorTypeaheadLoading(e: boolean): void {
    
    this.typeaheadRequestorLoading = e;
  
}
designationNameOnSelect(e: TypeaheadMatch):void
  {
    this.MaterialSentTo=e.item;
    this.flag=false;
    this.isSpinning=false;
    this.OutwardDetails.materialSentToVendorName=e.item;

  }
  
  onMaterialSentToSelect() {
    this.materialSentToDataSource= Observable.create((observer: any)=>{
      let txt = this.MaterialSentTo;
      if(txt.length>0){
        // this._addVendorService.GetDesignationByName(txt)
        // .pipe(takeUntil(this.unsubscribe$))
        // .subscribe(result => {
        //   this.userNameArray = result;
        //   observer.next(result);
        // });
      }
      });
        
  };

  removeMaterial(index:number){
    if(index > -1){
     this.materialList.splice(index,1);
    }
  }
  goBack() : void{
    this.location.back();
  }
getDataById(id: number) {
    let url =this.service_URL.OutwardDetails.GetDataById+'/'+id;
    //this.getOfficeData();
  this._dataContextService.get(url)
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe((res : any)=>{
    this.oldRequestData = res;
    //this.oldCopyMaterialList = Object.assign({}, res.materialList);
    this.oldCopyMaterialList = JSON.parse(JSON.stringify(res.materialList));
    this.EditOutwardDetails=res;
    this.OutwardDetails=this.EditOutwardDetails;
    this.RequestName=this.OutwardDetails.requestName;
    this.RequestSelected=this.OutwardDetails.requestTypeId;
    this.RequestTypeName=this.OutwardDetails.requestTypeName;
    this.RequestStatusName=this.OutwardDetails.status;
    this.OfficeName=this.OutwardDetails.officeName;
    this.RequestTypeDetails.name=this.OutwardDetails.requestTypeName;
    this.RequestTypeDetails.transactionStatusId=this.OutwardDetails.requestTypeId;
    this.MaterialSentTo=this.OutwardDetails.materialSentToVendorName;
    this.MaterialCarriedBy=this.OutwardDetails.materialCarriedByVendorName;
    
    this.AuthorizedBy=this.OutwardDetails.authorizedBy;
    this.LaApprov1=this.OutwardDetails.approverEmailL1;
    this.Appr1Name=this.OutwardDetails.approverEmailL1;
    this.Appr2Name=this.OutwardDetails.approverEmailL2;
    this.LaApprov2=this.OutwardDetails.approverEmailL2;
    this.PracticeSelected=this.OutwardDetails.practiceId;
    
    // Populate approvers based on selected practice, city, and office
    this.PracticeName = this.PracticeSelected;
    this.CitySelected=this.OutwardDetails.cityId;
    this.OfficeSelected=this.OutwardDetails.officeId;
    this.OfficeName = this.OutwardDetails.officeId;
    
    // Call filterApprovers to populate Appr1Data and Appr2Data properly
    this.filterApprovers();
    
    // Set selected approvers after filterApprovers has populated the arrays
    if(this.Appr1Data!=null && this.Appr1Data.length > 0 && this.Appr2Data!=null && this.Appr2Data.length > 0)
    {
      const appr1 = this.Appr1Data.find(x=>x.emailId===this.OutwardDetails.approverEmailL1);
      const appr2 = this.Appr2Data.find(x=>x.emailId===this.OutwardDetails.approverEmailL2);
      
      if(appr1) this.Appr1Selected = appr1.appUserID;
      if(appr2) this.Appr2Selected = appr2.appUserID;
    }
   this.Remarks=this.OutwardDetails.remark;
   
   // Filter office data based on selected city
   this.officeData = this.MasterList.officeList.filter((item) => {
    return item.cityID === this.CitySelected
  }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
   this.Purpose=this.OutwardDetails.purpose;
   this.OfficeDetails.officeID=this.OutwardDetails.officeId;
   //this.OfficeDetails.OfficeName=this.MasterList.officeList.filter(x=>x.officeID==this.OutwardDetails.officeId)[0].officeName;
   let formattedDate = (moment(this.OutwardDetails.requestDateTime)).format('MMM/DD/YYYY')
   let DueDate = (moment(this.OutwardDetails.returnDateTime)).format('MMM/DD/YYYY')
   let RevisedDate=(moment(this.OutwardDetails.revisedDate)).format('MMM/DD/YYYY')
   this.dateInputData.RequestDate=new Date(formattedDate);
   this.dateInputData.DueDate=new Date(DueDate);
   this.dateInputData.RevisedDate=new Date(RevisedDate);
   this.previousValidDueDate = new Date(DueDate);
   
   // Update due date and revised due date constraints based on the loaded request date
   this.updateDueDateConstraints(this.dateInputData.RequestDate);
   
   this.fTime =new Date(this.OutwardDetails.requestDateTime);
   this.fromtimevalue = this.GetTimeForDates(this.fTime);
   this.dTime=new Date(this.OutwardDetails.returnDateTime);
   this.rTime=new Date(this.OutwardDetails.revisedDate);
   this.revisedduetimevalue=this.GetTimeForDates(this.rTime);
   this.duetimevalue=this.GetTimeForDates(this.dTime);
   this.materialList=this.OutwardDetails.materialList;
   var len = this.materialList.length;
        for(var i=0;i<len;i++){
          this.materialList[i].name = res.materialList[i].name;
          this.materialList[i].quantity = res.materialList[i].quantity;
          this.materialList[i].notes = res.materialList[i].notes;
        }
    // Check if attachedFiles is not null and assign it
   if (this.OutwardDetails.attachedFiles && this.OutwardDetails.attachedFiles.length > 0) {
      this.attachedFiles = this.OutwardDetails.attachedFiles;
    } else {
        this.attachedFiles = [];
    }
  })

  }
  
  setOldValues(oldData: any, oldCopyMaterialList: any){
    this.oldValues.requestName = oldData.requestName;
    this.oldValues.requestType = oldData.requestTypeName;
    this.oldValues.returnDateTime = oldData.returnDateTime;
    this.oldValues.revisedDateTime = oldData.revisedDate;
    this.oldValues.revisedDateTime = new Date(oldData.revisedDate).toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
    this.oldValues.materialCarriedBy = oldData.materialCarriedByVendorName;
    this.oldValues.materialSentTo = oldData.materialSentToVendorName;
    this.oldValues.approverEmailL1 = oldData.approverEmailL1;
    this.oldValues.approverEmailL2 = oldData.approverEmailL2;
    this.oldValues.practiceName = oldData.practiceName;
    this.oldValues.city = oldData.cityName;
    this.oldValues.office = oldData.officeName;
    this.oldValues.remarks = oldData.remark;
   
    var oML: any = [];
    for(var i=0;i<oldCopyMaterialList.length;i++){
      oML.push(oldCopyMaterialList[i]);
    }
    this.oldValues.materials = oML;
    this.oldValues = Object.keys(this.oldValues).map(key => ({Name: key, Value: this.oldValues[key]}));
  }

  setNewValues(materialList: any){

    this.newValues.requestName = this.RequestName;
    this.newValues.requestType = this.RequestSelected == OutwardStatus.Returnable ? 'Returnable' : (this.RequestSelected == OutwardStatus.InternalMovement ? 'Internal movement' : 'Non-Returnable');
    this.newValues.returnDateTime = this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.DueDate.toDateString()+" "+this.duetimevalue).toISOString().replace('.000','');
    this.newValues.revisedDateTime = this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.RevisedDate.toDateString()+" "+this.revisedduetimevalue).toISOString()
    this.newValues.revisedDateTime = this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.RevisedDate.toDateString() + " " + this.revisedduetimevalue).toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
    this.newValues.materialCarriedBy = this.MaterialCarriedBy;
    this.newValues.materialSentTo = this.MaterialSentTo;
    // this.newValues.approverEmailL1 = this.Appr1Data.filter(x=>x.emailId===this.Appr1Name)[0].emailId;
    // this.newValues.approverEmailL2 = this.Appr2Data.filter(x=>x.emailId===this.Appr2Name)[0].emailId;
    if(!Number.isNaN(Number(this.Appr1Name)))
    {
      this.newValues.approverEmailL1=this.Appr1Data.filter(x=>x.appUserID==this.Appr1Name)[0].emailId;
    }
    else{
      this.newValues.approverEmailL1= this.Appr1Data.filter(x=>x.emailId===this.Appr1Name)[0].emailId;
    }

    if(!Number.isNaN(Number(this.Appr2Name)))
      this.newValues.approverEmailL2=this.Appr2Data.filter(x=>x.appUserID==this.Appr2Name)[0].emailId;
    else
      this.newValues.approverEmailL2= this.Appr2Data.filter(x=>x.emailId===this.Appr2Name)[0].emailId;
    
    this.newValues.practiceName = this.PracticeData.filter((x:any)=>x.practiceId==this.PracticeSelected)[0].name;
    this.newValues.city = this.cityData.filter(x => x.cityID == this.CitySelected)[0].cityName;
    // this.newValues.office = this.OfficeName;
    if(Number(this.OfficeName) >= 0){
      this.newValues.office=this.officeData.filter(x=>x.officeID==this.OfficeName)[0].officeName;
    }
    else{
      this.newValues.office=this.OfficeName;
    }
    this.newValues.remarks = this.Remarks==undefined?"":this.Remarks;

    var oML: any = [];
    for(var i=0;i<materialList.length;i++){
      oML.push(materialList[i]);
    }
    this.newValues.materials = oML;
    this.newValues = Object.keys(this.newValues).map(key => ({Name: key, Value: this.newValues[key]}));
  }

  saveToAudit(oldData: any){
    var arr  = [],
    keys = Object.keys(this.oldCopyMaterialList);

    for(var i=0,n=keys.length;i<n;i++){
      var key  = keys[i];
      arr[key] = this.oldCopyMaterialList[key];
    }

    this.setOldValues(oldData,arr);
    this.setNewValues(oldData.materialList);

    let auditData: TransactionAuditTrail = new TransactionAuditTrail();
    auditData.changedBy = localStorage.getItem('email');
    auditData.actionPerformed = "Update";
    auditData.actionPerformedOn = "Outward";
    auditData.dateChanged = new Date();
    auditData.primaryKey = oldData.serialNumber;
    auditData.statusChange = [];
    let auditGIText: Array<AuditData> = new Array<AuditData>();

    this.oldValues.forEach((oldValues) => {
      this.newValues.forEach((newValues) => {
        if(oldValues.Name == 'revisedDateTime' && newValues.Name == 'revisedDateTime'){
          if(oldValues.Name === newValues.Name){
            if(oldValues.Value != newValues.Value){
              var obj : AuditData = new AuditData();
              obj.changedAttribute = "Due Date";
              obj.oldValue = oldValues.Value;
              obj.newValue = newValues.Value;
              auditGIText.push(obj);
            }
          }
        }
      })
    })

    this.oldValues.forEach((oldValues) => {
      this.newValues.forEach((newValues) => {
        if(oldValues.Name !== 'materials' && newValues.Name !== 'materials' && oldValues.Name !== 'revisedDateTime' && newValues.Name !== 'revisedDateTime'){
          if(oldValues.Name === newValues.Name){
            if(oldValues.Value != newValues.Value){
              var obj : AuditData = new AuditData();
              obj.changedAttribute = oldValues.Name;
              obj.oldValue = oldValues.Value;
              obj.newValue = newValues.Value;
              auditGIText.push(obj);
            }
          }
        }
      })
    })

    auditData.generalInformation = auditGIText;
    
    let auditMaterialText: Array<AuditMaterial> = new Array<AuditMaterial>();

  arr.forEach((OM) => {
    var flag = false;
    oldData.materialList.forEach((NM) => {
        if(OM.materialId == NM.materialId){
            flag = true;
            if(OM.name !== NM.name){
              var obj: AuditMaterial = new AuditMaterial();
              obj.changedAttribute = "Name";
              obj.oldValue = OM.name;
              obj.newValue = NM.name;
              obj.materialName = OM.name;
              auditMaterialText.push(obj);
            }
            if(OM.notes !== NM.notes){
                var obj: AuditMaterial = new AuditMaterial();
                obj.changedAttribute = "Notes";
                obj.oldValue = OM.notes;
                obj.newValue = NM.notes;
                obj.materialName = OM.name;
                auditMaterialText.push(obj);
            }
            if(OM.quantity != NM.quantity){
                var obj: AuditMaterial = new AuditMaterial();
                obj.changedAttribute = "Quantity";
                obj.oldValue = OM.quantity.toString();
                obj.newValue = NM.quantity.toString();
                obj.materialName = OM.name;
                auditMaterialText.push(obj);
            }
        }
    });
    if(!flag){
        var obj: AuditMaterial = new AuditMaterial();
        obj.changedAttribute = "Delete Material";
        obj.oldValue = OM.name;
        obj.newValue = null;
        obj.materialName = OM.name;
        auditMaterialText.push(obj);
    }
});

  oldData.materialList.forEach((NM) => {
    if(NM.MaterialId == 0){
        var obj: AuditMaterial = new AuditMaterial();
        obj.changedAttribute = "Add Material";
        obj.oldValue = null;
        obj.newValue = NM.name;
        obj.materialName = NM.name;
        auditMaterialText.push(obj);
    }
  });

    auditData.material = auditMaterialText;
    
    if(oldData.status == "Declined")
    {
      let statuschangeAudit: AuditData = new AuditData();
      statuschangeAudit.changedAttribute = "Status";    
      statuschangeAudit.oldValue = "Declined";
      statuschangeAudit.newValue = "Created";
      auditData.statusChange.push(statuschangeAudit);
    
    }

    this.auditResult = auditData;
  }

  submit(){
    
   if(this.iseditTransaction)
   {
    this.deletedFileIds.forEach(fileId => {
      let url = this.service_URL.OutwardDetails.DeleteAttchedFile + '/' + fileId;
      this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
          if (res == "1") {
            this.toast.success("File marked as inactive successfully!");
          }
        });
    });
    
    this.EditDetails.requestId=this.id;
    this.EditDetails.requestName=this.RequestName;
    this.EditDetails.requestTypeName="";
    // this.EditDetails.requestTypeId=this.RequestTypeDetails.transactionStatusId;
    this.EditDetails.requestTypeId=this.RequestSelected;
    //this.RequestTypeData.filter(x=>x.name==this.RequestTypeName)[0].transactionStatusId;
    if(!Number.isNaN(Number(this.Appr1Name)))
    {
    this.EditDetails.approverEmailL1=this.Appr1Data.filter(x=>x.appUserID==this.Appr1Name)[0].emailId;
    }
    else{
      this.EditDetails.approverEmailL1= this.Appr1Data.filter(x=>x.emailId===this.Appr1Name)[0].emailId;
      //this.EditDetails.approverEmailL1=this.Appr1Data.filter(x=>x.firstLastName==this.Appr1Name)[0].emailId;
    }

    if(!Number.isNaN(Number(this.Appr2Name)))
    this.EditDetails.approverEmailL2=this.Appr2Data.filter(x=>x.appUserID==this.Appr2Name)[0].emailId;
    else
    this.EditDetails.approverEmailL2= this.Appr2Data.filter(x=>x.emailId===this.Appr2Name)[0].emailId;
    
    this.EditDetails.isActive=true;
    this.EditDetails.materialSentToVendorId=0;
    this.EditDetails.materialCarriedByVendorId=0;
    this.EditDetails.materialSentToVendorName=this.MaterialSentTo;
    this.EditDetails.materialCarriedByVendorName=this.MaterialCarriedBy;
    this.EditDetails.materialList=this.materialList;
    this.EditDetails.practiceId=this.PracticeSelected;
    this.EditDetails.practiceName="";
    this.EditDetails.gatepassNumber=0;
    this.EditDetails.remark=this.Remarks==undefined?"":this.Remarks;
    this.EditDetails.purpose=this.Purpose;
    this.EditDetails.requestDateTime=new Date(this.dateInputData.RequestDate.toDateString()+" "+this.fromtimevalue).toISOString();
    if(this.dateInputData.DueDate!=null){
    this.EditDetails.returnDateTime=this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.DueDate.toDateString()+" "+this.duetimevalue).toISOString()
    }
   
    this.EditDetails.revisedDate=this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.RevisedDate.toDateString()+" "+this.revisedduetimevalue).toISOString()
    
    this.EditDetails.statusId=this.oldRequestData.statusId;
    this.EditDetails.cityId=this.CitySelected;
    if(!Number.isNaN(Number(this.OfficeName)))
    {
      this.EditDetails.officeId=this.OfficeName;}
    else{
      
      this.EditDetails.officeId=this.officeData.filter(x=>x.officeName==this.OfficeName)[0].officeID;
    }
    this.EditDetails.cityName="";
    this.EditDetails.status="created";
    this.EditDetails.officeName="";
    this.EditDetails.authorizedBy=this.AuthorizedBy;
    this.EditDetails.updatedBy=localStorage.getItem('email');
    this.EditDetails.declinedByNotes="";
    this.EditDetails.createdBy=localStorage.getItem('email');
    if (this.attachedFilesDetails && this.attachedFilesDetails.length > 0) {
      this.EditDetails.attachedFiles =  this.attachedFilesDetails;
    } else {
      this.EditDetails.attachedFiles = []; // Handle the case where there are no attached files
    }
    /*if ((this.attachedFilesDetails && this.attachedFilesDetails.length > 0) || (this.attachedFiles && this.attachedFiles.length > 0)) {
      this.EditDetails.attachedFiles = this.attachedFilesDetails.length > 0 ? this.attachedFilesDetails : this.attachedFiles;
    } else {
      this.EditDetails.attachedFiles = []; // Handle the case where there are no attached files
    }*/
     this.saveToAudit(this.oldRequestData);   
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.EditOutwardReq, this.EditDetails)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
        this.toast.success("Successfully Updated Request Details!");
    },
    (err) => {
      console.log(err);
    },
    () => {
      //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : this.auditResult.actionPerformed,
        actionPerformedOn : this.auditResult.actionPerformedOn,
        changedBy : this.auditResult.changedBy,
        dateChanged : this.auditResult.dateChanged,
        primaryKey : this.auditResult.primaryKey,
        generalInformation : this.auditResult.generalInformation,
        material : this.auditResult.material,
        statusChange :this.auditResult.statusChange,
        messageText : this.auditResult.generalInformation
      };
      
      this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
        this.location.back();
      },
      (err) => {
        console.log(err);
      })
      auditParams.messageText.forEach((element: any) => {
        if(element.changedAttribute == "Due Date"){

          if (Array.isArray(this.auditResult.generalInformation)) {
            this.auditResult.generalInformation.forEach(info => {
              if (info.changedAttribute === 'Due Date') {
                this.auditResult.generalInformation=[];
               this.auditResult.generalInformation.push(info);
              }
            });
          }
        
          let auditParamsforconfigtrail = {
            actionPerformed : this.auditResult.actionPerformed,
            actionPerformedOn : this.auditResult.actionPerformedOn,
            changedBy : this.auditResult.changedBy,
            dateChanged : this.auditResult.dateChanged,
            primaryKey : this.auditResult.primaryKey,
            generalInformation : this.auditResult.generalInformation,
            material : this.auditResult.material,
            statusChange :this.auditResult.statusChange,
            messageText : this.auditResult.generalInformation
          };
          let tokenNew = localStorage.getItem('accessToken');
      var headers=new HttpHeaders({ 
        'Authorization' : `Bearer ${tokenNew}`
      })
      this.http.post<any>(this.service_URL.AuditTrail.saveconfigaudittrail, auditParamsforconfigtrail,{headers:headers})
        .subscribe(res => { 
          console.log(res);
        },
        (err)=>{
          console.log(err);
        })
        }
      });
     
    });
    
   
   }
   else{
    // Get current time when submit button is clicked
    //const currentTime = new Date();
    //this.fromtimevalue = this.GetTimeForDates(currentTime);
    
    this.EditDetails.requestName=this.RequestName;
    this.EditDetails.requestTypeName="";
    this.EditDetails.requestTypeId=this.RequestTypeName;
    //this.RequestTypeData.filter(x=>x.name==this.RequestTypeName)[0].transactionStatusId;
    this.EditDetails.approverEmailL1=this.Appr1Data.filter(x=>x.appUserID==this.Appr1Name)[0].emailId;
    this.EditDetails.approverEmailL2=this.Appr2Data.filter(x=>x.appUserID==this.Appr2Name)[0].emailId;
    this.EditDetails.isActive=true;
    this.EditDetails.materialSentToVendorId=0;
    this.EditDetails.materialCarriedByVendorId=0;
    this.EditDetails.materialSentToVendorName=this.MaterialSentTo;
    this.EditDetails.materialCarriedByVendorName=this.MaterialCarriedBy;
    this.EditDetails.materialList=this.materialList;
    this.EditDetails.practiceId=this.PracticeName;
    this.EditDetails.practiceName="";
    this.EditDetails.gatepassNumber=0;
    //this.EditDetails.serialNumber="";
    this.EditDetails.remark=this.Remarks==undefined?"":this.Remarks;
    this.EditDetails.purpose=this.Purpose;
    this.EditDetails.requestDateTime=new Date(this.dateInputData.RequestDate.toDateString('MMM/dd/y')+" "+this.fromtimevalue).toISOString();
    //this.dateInputData.RequestDate;
    if(this.dateInputData.DueDate!=null){
    this.EditDetails.returnDateTime=this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.DueDate.toDateString('MMM/dd/y')+" "+this.duetimevalue).toISOString();
    }
    this.EditDetails.revisedDate=this.RequestSelected == OutwardStatus.NonReturnable ? null : new Date(this.dateInputData.DueDate.toDateString('MMM/dd/y')+" "+this.duetimevalue).toISOString();
    //this.dateInputData.DueDate;
    this.EditDetails.statusId=4;
    this.EditDetails.cityId=this.CitySelected;
    this.EditDetails.officeId=this.OfficeName;
   
    this.EditDetails.cityName= this.cityData.filter(x => x.cityID == this.CitySelected)[0].cityName;
    this.EditDetails.status="created";
    this.EditDetails.officeName=this.officeData.filter(x=>x.officeID==this.OfficeName)[0].officeName;
    
    this.EditDetails.authorizedBy=this.AuthorizedBy==undefined?"":this.AuthorizedBy;
    this.EditDetails.updatedBy=localStorage.getItem('email');
    this.EditDetails.declinedByNotes="";
    this.EditDetails.createdBy=localStorage.getItem('email');
    if (this.attachedFiles && this.attachedFiles.length > 0) {
      this.EditDetails.attachedFiles = this.attachedFiles;
    } else {
      this.EditDetails.attachedFiles = []; // Handle the case where there are no attached files
    }

    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.AddOutwardReq, this.EditDetails)
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(res => {
    this.toast.success("Successfully Added Request Details!");
    this.location.back();
  });
  }
}

increase(num: any){
  this.materialList[num].quantity++;
}

decrease(num: any){
  if(this.materialList[num].quantity != 0){
    this.materialList[num].quantity--;
  }
}
UploadMaterial(){
   
    this.modalRef = this.modalService.show(UploadMaterialComponent,{
      initialState : {
        requestType: 'Outward' 
      }
    })
    this.modalRef.setClass(ModalSize.Large);
    this.modalRef.content.event.subscribe(res => {
      console.log(res);
    });

  }
  deleteFile(index: number): void {
    if (this.iseditTransaction) {
      if (this.attachedFiles && this.attachedFiles.length > 0) {
        const fileId = this.attachedFiles[index].fileId;
        if (fileId !== null && fileId !== undefined) {
          this.deletedFileIds.push(fileId);
          this.attachedFiles.splice(index, 1);
        
        } else {
          const fileName = this.attachedFiles[index].name;
          const subscription = this.fileService.files$.subscribe(files => {
            const fileIndex = files.findIndex(x => x.name === fileName);
            if (fileIndex !== -1) {
              this.fileService.removeFile(fileIndex);
              this.attachedFiles.splice(index, 1);
              // Remove the file from attachedFilesDetails using fileId
              const attachedFileIndex = this.attachedFilesDetails.findIndex(file => file.name === fileName);
              if (attachedFileIndex !== -1) {
                this.attachedFilesDetails.splice(attachedFileIndex, 1);
              }
            }
            subscription.unsubscribe(); // Unsubscribe after use
          });
        }
      }
    } else {
      this.fileService.removeFile(index);
      this.attachedFiles.splice(index, 1);
    }
  }
  closeUploadMaterial(): void {
    this.showUploadMaterial = false;
   
  }
  handleFileData(fileData: { name: string, type: string, data: string | ArrayBuffer, requestType: string}): void {
    this.attachedFiles.push(fileData);
    this.fileService.updateFiles(this.attachedFiles);
  }
  ngOnDestroy() {
    
    this.clearAttachedFiles();
  }
  clearAttachedFiles() {
    this.attachedFiles = [];
    this.attachedFilesDetails = [];
    this.fileService.clearFiles();
  }
 
}

